import { Banner } from '@/components/Banner';
import { LabradorComponent } from '@/types/component';

export const LabradorBanner: LabradorComponent = ({ type, meta }) => {
  return <Banner />;
};
